import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

export interface AvailableCoupon {
  id: string;
  code: string;
  name: string;
  discount_label: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UsedCoupon {
  usage_id: string;
  coupon_id: string;
  code: string;
  name: string;
  /** Discount amount saved in cents (display currency) */
  discount_amount_display: number;
  applied_at: string;
  order_id: string;
}

export interface CustomerCoupons {
  available: AvailableCoupon[];
  used: UsedCoupon[];
}

function getClient() {
  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });
}

export async function getUserCoupons(userId: string): Promise<CustomerCoupons> {
  try {
    const res = await getClient().getUserCoupons(userId);
    return res.data;
  } catch {
    return { available: [], used: [] };
  }
}
